import type { FC, PropsWithChildren } from 'react';
import { createContext, memo, useContext } from 'react';

interface IContext {
    /** Режим отладки */
    isDebugMode: boolean;
}

const debugEnvState = !!process.env.IS_STORYBOOK_ENV;
const Context = createContext<IContext>({ isDebugMode: debugEnvState });

const contextValue: IContext = {
    isDebugMode: debugEnvState,
};

/** Состояние режима отладки */
export const useDebugStore = () => useContext(Context);

const DebugStore: FC<PropsWithChildren> = ({ children }) => {
    return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export default memo(DebugStore);
